import sanitize from "helpers/sanitize";
import { Button } from "components/ui";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "translation/useTranslation";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";

export default function ExpandableHtml({ html, className = '', ...rest }) {
  const { translate } = useTranslation();

  const divRef = useRef(null);
  const [expanded, setExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const el = divRef.current;
    if (el) {
      setIsOverflowing(el.scrollHeight > 56);
      setLoaded(true);
    }
  }, [html]);

  const handleClick = (e) => {
    e?.preventDefault();
    e?.currentTarget?.blur();
    setExpanded(!expanded);
  };

  return <div>
    <div data-testid="expandable-content"
      ref={divRef}
      className={`${className} ${(isOverflowing && !expanded) ? 'line-clamp-2 cursor-pointer' : ''} ${loaded ? '' : 'line-clamp-2'}`}
      onClick={(isOverflowing && !expanded) ? () => setExpanded(true) : null}
    >
      <span
        className={`div-html break-word ${expanded ? 'div-html-expanded' : ''}`}
        dangerouslySetInnerHTML={{ __html: sanitize(html, { ADD_ATTR: ["target", "rel"] }) }}
      />
    </div>

    <div className="text-right">
      {
        isOverflowing && <Button variant="ghost" size="inline" icon={`text-big bi-bold ${!expanded ? 'bi-arrow-down' : 'bi-arrow-up'}`} className="mt-1" onClick={handleClick} data-testid="expandable-toggle" data-tooltip-id="expand-collapse-tooltip" data-tooltip-content={expanded ? translate('tooltips.balanced_scorecard.collapse', 'Fehler') : translate('tooltips.balanced_scorecard.expand', 'Expandieren')} />
      }
    </div>
    <ReactTooltip id="expand-collapse-tooltip" place="bottom" />
  </div>;
}
